import { attachSwipeEvents } from './utils/slick-swipe-event.js';

const init = () => {

  let isRTL = false;
  if ( $('html').attr('dir') === 'rtl' ) {
    isRTL = true;
  }

  $('.carousel__container').slick({
    dots: true,
    adaptiveHeight: true,
    autoplay: false,
    swipeToSlide: true,
    rtl: isRTL
  });

  $('.carousel__container__responsive').slick({
    dots: true,
    adaptiveHeight: true,
    autoplay: true,
    swipeToSlide: true,
    rtl: isRTL,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1074,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1073,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 722,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.carousel__container__rgs').slick({
    dots: false,
    adaptiveHeight: true,
    autoplay: false,
    swipeToSlide: false,
    rtl: isRTL,
    infinite: true,
    speed: 400,
    slidesToShow: 2.2,
    slidesToScroll: 1,
    arrows: true,
    cssEase: 'linear',
    touchThreshold: 40,
    responsive: [
      {
        breakpoint: 1073,
        settings: {
          slidesToShow: 2.15
        }
      },
      {
        breakpoint: 722,
        settings: {
          slidesToShow: 1.1
        }
      }
    ]
  });

  $('.carousel__container__rgs-images').slick({
    dots: true,
    adaptiveHeight: true,
    autoplay: true,
    swipeToSlide: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
    cssEase: 'linear',
    touchThreshold: 40
  });

  const carouselRgsImages = $('.carousel__container__rgs-images'); 

  $(carouselRgsImages).on('touchstart mousedown', function(e) {
    e.stopPropagation();
  });

  function stopAllAutoplay() {
    $(carouselRgsImages).slick('slickPause');
  }

  function startAllAutoplay() {
    $(carouselRgsImages).slick('slickPlay');
  }

  $(carouselRgsImages).on('mousedown touchstart', function() {
    stopAllAutoplay();
  }).on('afterChange', function() {
    startAllAutoplay();
  });

  $('.rgs-carousel-general-img-list-promo').slick({
    dots: true,
    adaptiveHeight: true,
    autoplay: true,
    swipeToSlide: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    pauseOnHover: true,
    cssEase: 'linear',
    touchThreshold: 40
  });

  $('.rgs-carousel-block').slick({
    dots: true,
    adaptiveHeight: true,
    autoplay: true,
    swipeToSlide: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    pauseOnHover: true,
    cssEase: 'linear',
    touchThreshold: 40
  });
    
  attachSwipeEvents('.rgs-carousel-block');
  attachSwipeEvents('.carousel__container__rgs');
  attachSwipeEvents('.carousel__container__rgs-images');
  attachSwipeEvents('.rgs-carousel-general-img-list-promo');

  // Carousel for Header Hero
  // Access SCSS-defined CSS variables with fallback
  const activeDotColor = getComputedStyle(document.documentElement).getPropertyValue('--brand-color-1').trim() || '#ff0000';
  const defaultDotColor = getComputedStyle(document.documentElement).getPropertyValue('--hero-header-carousel-bg-dots').trim() || '#cccccc';

  let $heroCarousel = $('.carousel__container__hero');
  let autoplayTime = $heroCarousel.data('autoplay') || 5;
  let isPaused = false,
    progressPercent = 0,
    progressInterval;

  // Initialize the carousel
  $heroCarousel.slick({
    draggable: true,
    adaptiveHeight: false,
    dots: true,
    mobileFirst: true,
    pauseOnDotsHover: true,
    rtl: false,
    arrows: true,
    fade: true,
    cssEase: 'linear',
  });

  // Start the progress for the active dot
  const startDotProgress = () => {
    resetDotProgress();
    progressPercent = 0;
    isPaused = false;
    progressInterval = setInterval(updateDotProgress, 10);
  };

  // Update the progress of the active dot
  const updateDotProgress = () => {
    if (!isPaused) {
      progressPercent += 1 / (autoplayTime + 0.1);
      const activeDot = document.querySelector('.slick-dots li.slick-active');
      if (activeDot) {
        activeDot.style.background = `linear-gradient(to right, ${activeDotColor} ${progressPercent}%, ${defaultDotColor} ${progressPercent}%)`;
      }

      if (progressPercent >= 100) {
        $heroCarousel.slick('slickNext');
        startDotProgress();
      }
    }
  };

  // Reset the progress of all dots to default state
  const resetDotProgress = () => {
    clearInterval(progressInterval);
    document.querySelectorAll('.slick-dots li').forEach(dot => {
      dot.style.background = defaultDotColor;
    });
  };

  // Pause/resume progress on hover over carousel or search form
  document.querySelectorAll('.carousel__container__hero, .tour-search-form').forEach(element => {
    element.addEventListener('mouseenter', () => { isPaused = true; });
    element.addEventListener('mouseleave', () => { isPaused = false; });
  });

  // Reset and restart progress when clicking on dots
  document.querySelectorAll('.slick-dots li').forEach(dot => {
    dot.addEventListener('click', () => {
      resetDotProgress();
      startDotProgress();

      // Check if the mouse is still hovering after the click
      if (document.querySelector('.carousel__container__hero:hover, .tour-search-form:hover')) {
        isPaused = true;
      }
    });
  });

  // Restart the dot progress when the slide changes
  $heroCarousel.on('beforeChange', () => {
    resetDotProgress();
    startDotProgress();
  });

  // Start the dot progress when the document is ready
  startDotProgress();
};

export { init }